reduceChildrenToParentThreads